/**
 * Flickity RTL Fix
 * Watches for Flickity sliders and fixes their RTL positioning
 * Uses MutationObserver to catch dynamically loaded sliders
 */

(function() {
  'use strict';

  // Check if RTL language
  function isRTL() {
    const rtlLangs = ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'];
    const htmlLang = (document.documentElement.lang || '').toLowerCase();
    return rtlLangs.some(lang => htmlLang.includes(lang));
  }

  if (!isRTL()) {
    return; // Exit if not RTL
  }

  const debugMode = window.location.search.includes('debug_rtl=true');

  /**
   * Fix a Flickity slider
   */
  function fixSlider(element) {
    if (!element || !element.classList.contains('flickity-enabled')) {
      return;
    }

    // Check if already fixed
    if (element.dataset.rtlFixed === 'true') {
      return;
    }

    // SKIP fixing if element has data-native-rtl attribute (allows native RTL)
    if (element.hasAttribute('data-native-rtl')) {
      if (debugMode) console.log('⏩ Skipping fix for native RTL slider:', element);
      return;
    }

    if (debugMode) {
      console.log('🔧 Fixing Flickity slider:', element);
    }

    // Get Flickity instance
    let instance = null;
    if (window.Flickity && window.Flickity.data) {
      instance = window.Flickity.data(element);
    }

    if (debugMode) {
      console.log('   Instance:', instance ? 'Found' : 'NOT FOUND');
    }

    if (instance) {
      if (debugMode) {
        console.log('   Current options:', {
          rightToLeft: instance.options.rightToLeft,
          cellAlign: instance.options.cellAlign
        });
      }

      // If using rightToLeft mode, fix it
      if (instance.options.rightToLeft === true || element.classList.contains('flickity-rtl')) {
        if (debugMode) {
          console.log('   Destroying and recreating with cellAlign: right...');
        }

        // Get current options
        const options = Object.assign({}, instance.options, {
          rightToLeft: false,
          cellAlign: 'right',
          contain: false
        });

        // Destroy and recreate
        instance.destroy();
        new window.Flickity(element, options);

        if (debugMode) {
          console.log('   ✅ Fixed!');
        }
      }
    }

    // Mark as fixed
    element.dataset.rtlFixed = 'true';
  }

  /**
   * Check and fix all Flickity sliders
   */
  function checkAllSliders() {
    const sliders = document.querySelectorAll('.flickity-enabled');
    if (debugMode && sliders.length > 0) {
      console.log(`🔍 Found ${sliders.length} Flickity sliders`);
      sliders.forEach(slider => {
        console.log('   Slider:', slider, 'Has flickity-rtl:', slider.classList.contains('flickity-rtl'));
      });
    }
    sliders.forEach(fixSlider);
  }

  /**
   * Observe DOM for new Flickity sliders
   */
  function observeDOM() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            // Check the node itself
            if (node.classList && node.classList.contains('flickity-enabled')) {
              fixSlider(node);
            }
            // Check descendants
            if (node.querySelectorAll) {
              node.querySelectorAll('.flickity-enabled').forEach(fixSlider);
            }
          }
        });

        // Check for class changes
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('flickity-enabled')) {
            fixSlider(target);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    if (debugMode) {
      console.log('👁️  Observing DOM for Flickity sliders...');
    }
  }

  /**
   * Initialize
   */
  function init() {
    if (debugMode) {
      console.log('🚀 Flickity RTL Fix initialized');
    }

    // Check existing sliders periodically
    let checks = 0;
    const maxChecks = 20; // Check for 10 seconds (20 * 500ms)
    const checkInterval = setInterval(() => {
      checkAllSliders();
      checks++;
      if (checks >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 500);

    // Observe for new sliders
    if (document.body) {
      observeDOM();
    } else {
      document.addEventListener('DOMContentLoaded', observeDOM);
    }
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();